import { useState, useCallback, useRef, useEffect } from 'react'
import { CrossStatisticsService } from '../../../services'
import { COMPARE_TYPES } from '../constants'
import { formatDateParam } from '../../../utils/dateHelpers'

const useCrossStatisticsApi = (formUrl, formState, initialStatistics) => {
  const [statistics, setStatistics] = useState(initialStatistics)
  const [loading, setLoading] = useState(false)
  const [fetchError, setFetchError] = useState(null)
  const initialFetchDone = useRef(false)

  const {
    variableId,
    questionIds,
    startDate,
    endDate,
    compareType
  } = formState

  const fetchStatistics = useCallback(async() => {
    const isGrade = compareType === COMPARE_TYPES.GRADE

    if (!variableId || !isGrade && questionIds.length === 0) {
      setStatistics(null)
      return
    }

    setLoading(true)
    setFetchError(null)

    try {
      const data = await CrossStatisticsService.getStatistics(formUrl, {
        variableId,
        questionId: isGrade ? null : questionIds[0],
        startDate: formatDateParam(startDate),
        endDate: formatDateParam(endDate),
        statisticsType: compareType === COMPARE_TYPES.SELECTION ? null : compareType
      })
      setStatistics(data.statistics)
    } catch {
      setStatistics(null)
      setFetchError('Erreur lors du chargement des statistiques')
    } finally {
      setLoading(false)
    }
  }, [variableId, questionIds, startDate, endDate, compareType, formUrl])

  useEffect(() => {
    const canFetch = variableId && (compareType === COMPARE_TYPES.GRADE || questionIds.length > 0)
    if (!initialFetchDone.current && canFetch) {
      initialFetchDone.current = true
      fetchStatistics()
    }
  }, [variableId, questionIds, compareType, fetchStatistics])

  const resetStatistics = useCallback(() => setStatistics(null), [])

  return {
    statistics,
    loading,
    fetchError,
    fetchStatistics,
    resetStatistics
  }
}

export default useCrossStatisticsApi
